<template>
	<svg
		:class="sizeClass"
		viewBox="0 0 15 15"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M8.42179 7.50009L3.77161 2.84991L5.01409 1.60742L10.9068 7.50009L5.01409 13.3928L3.77161 12.1503L8.42179 7.50009Z"
			:fill="color"
		/>
	</svg>
</template>

<script setup>
const props = defineProps({
	color: {
		type: String,
		default: '#929497'
	},
	sizeClass: {
		type: String,
		default: 'h-[15px] w-[15px]'
	}
});
</script>